
import { Toast, PullRefresh, SwipeCell, Dialog, Badge, Field } from "vant";
Vue.use(Badge);
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  extractInfo,
  extractApply,
  userSign,
  querySvipUserInfo,
} from "@/req/pay";
@Component({
  components: { PullRefresh, SwipeCell, Badge },
})
export default class Logout extends Vue {
  @Prop({ default: {}, type: Object }) public extractData;
  @Prop({ default: false, type: Boolean }) public clause;
  @Prop({ default: false, type: Boolean }) public goldSign;

  public btnAcivte = false;
  public alipayAccount = "";
  public explainShow = false;
  public money: any = "";
  public canExtract: any = null;
  public infoList: any = {};
  public type: any = 2;
  public loadingShow = false;
  public svipClause = false;
  public svipLevel = 0;
  public getSvipInfoNum = 0;

  public mounted() {
    this.infoList = this.extractData.infoList;
    this.type = this.extractData.type;
    this.getCanExtract();
    this.getSvipInfo();
  }
  @Watch("extractData", { deep: true })
  public extractDataChange(val) {
    this.infoList = val.infoList;
    this.type = val.type;
    this.getCanExtract();
  }
  public getCanExtract() {
    this.canExtract =
      this.type == 1
        ? this.$store.state.user.info.gold
        : this.$fn.byHundred(this.$store.state.user.info.trade_coin);
  }
  public onReset() {
    this.money = "";
    this.alipayAccount = "";
  }
  // 提现
  public onExtract() {
    this.efficacy();
  }
  // 全部提现
  public allWithdrawal() {
    if (this.canExtract <= 0) return Toast("无可提现金额");
    if (this.type == 1) {
      if (this.canExtract < 100) return (this.money = 0);
      this.money = Math.floor(this.canExtract / 100);
      return;
    }
    if (this.canExtract > 100000) {
      this.money = 100000;
    } else {
      this.money = Math.floor(this.canExtract);
    }
    this.efficacy();
  }
  // 效验
  public async efficacy() {
    if (Number(this.type) === 1) {
      const page: any = (window as any).extractPage;
      if (page && typeof page.checkFaceSign === "function") {
        const canExtract = await page.checkFaceSign();
        if (!canExtract) return;
      }
    }
    const min = this.infoList.minExtractMoney;
    if (this.infoList.is_no_audit == 1) return;
    if (this.alipayAccount == "") return Toast("支付宝账号不能为空");
    if (!this.clause) return Toast("请勾选下方合作协议");
    if (this.money == "") return Toast("提现金额不能为空");
    if (this.money < min) return Toast(`最低${min}元起提`);
    if (this.type == 1) {
      if (this.money * 100 > this.canExtract)
        return Toast("超出最大可提现金额");
    } else {
      if (this.money > this.canExtract) return Toast("超出最大可提现金额");
    }
    this.$emit("efficacyNum", this.money);
  }
  public secondEfficacy() {
    if (!this.goldSign && this.type == 1) {
      this.loadingShow = true;
      this.onUserSign();
      return;
    }
    this.modalShow(1);
  }
  // ModalShow
  public modalShow(id) {
    const obj = {
      id,
      money: this.money,
      account: this.alipayAccount,
      svipClause: this.svipClause,
    };
    this.$emit("modalShow", obj);
  }
  public onInput(value) {
    if (value > 100000) {
      this.money = 100000;
    } else {
      this.money = value;
    }
    if (value.length == 0) {
      this.btnAcivte = false;
    } else {
      this.btnAcivte = true;
    }
  }

  // 金币提现签约查询接口
  public async onUserSign() {
    try {
      const res = await userSign({
        token: this.$fn.cookies.getToken(),
      });
      if (res.code == 200) {
        this.$emit("update:goldSign", true);
        this.modalShow(1);
      } else {
        Toast(res.msg);
      }
    } finally {
      this.loadingShow = false;
    }
  }

  public async getSvipInfo() {
    if (!this.$store.state.user.info.id) {
      this.getSvipInfoNum = this.getSvipInfoNum + 1;
      if (this.getSvipInfoNum > 3) return;
      const thah = this;
      setTimeout(() => {
        thah.getSvipInfo();
      }, 1000);
      return;
    }
    const res = await querySvipUserInfo({
      userId: this.$store.state.user.info.id,
    });
    if (res.code == 200) {
      this.svipLevel = res.data.svipLevel;
    }
  }
  // 手续费计算
  public getServiceCharge() {
    if (!this.money) return 0;
    // 得出提现所付手续费
    let num =
      (this.money * this.infoList.minExtarctRatio) / 100
        ? (this.money * this.infoList.minExtarctRatio) / 100
        : 0;
    const minNum = parseInt(this.infoList.minExtarctCharge, 0);
    num = num > minNum ? num : minNum;
    if (this.svipClause) {
      // 得出减免后的 提现所付手续费
      let limitPct = (num * this.infoList.svip_value_use_limit_pct) / 100;
      num = num - limitPct;
      limitPct =
        limitPct - this.infoList.coupon_can_use_money > 0
          ? limitPct - this.infoList.coupon_can_use_money
          : 0;
      num = num + limitPct;
    }
    return num ? num.toFixed(2) : 0;
  }
  // 当前减免额度计算
  public getCanUseMoney() {
    if (!this.money) return 0;
    let num = 0;
    if (this.svipClause) {
      const minNum = parseInt(this.infoList.minExtarctCharge, 0);
      let currentNum = (this.money * this.infoList.minExtarctRatio) / 100;
      currentNum = currentNum < minNum ? minNum : currentNum;
      currentNum = (currentNum * this.infoList.svip_value_use_limit_pct) / 100;
      const couponCanUseMoney = this.infoList.coupon_can_use_money;
      num = currentNum >= couponCanUseMoney ? couponCanUseMoney : currentNum;
    }
    return "-" + (num ? num.toFixed(2) : 0);
  }
  public svipClauseChange(e) {
    this.getServiceCharge();
    this.getCanUseMoney();
  }
}
